import { Modal } from "react-bootstrap";
import backIcon from "../../../images/arrow-left-solid.png";
import ProductDetailsModalPage from "./product-details-parent/ProductDetailsModalPage.js";
import ProductComboListModalPage from "./product-combo-list/ProductComboListModalPage.js";
import ProductComboChildModalPage from "./product-combo-child/ProductComboChildModalPage.js";
import ModifierComboGroupsListModalPage from "./modifier-combo-groups-list/ModifierComboGroupsListModalPage.js";
import ModifierComboGroupDetailsModalPage from "./modifier-combo-group-details/ModifierComboGroupDetailsModalPage.js";

export default function ProductModal(props) {
    
    // Product Parent, Product Child or List
    let modalBody;
    if (props.productModalDisplay.showModalPage === "Parent Details") { // Regular Product Details
        modalBody = 
            <>
                <div className="modal-header">
                    <h1 className="modal-title fs-5">{props.productModalDisplay.productType === "Regular" ? "Product Details" : "Product Combo Details"}</h1>
                    <button type="button" className="btn-close" aria-label="Close" onClick={props.handleProductModalClose} disabled={props.addToCartError.ButtonsDisabled}></button>
                </div>
                <ProductDetailsModalPage
                    // General
                    productModalDisplay={props.productModalDisplay}
                    currentLocation={props.currentLocation}
                    handleProductFormSubtractQuantity={props.handleProductFormSubtractQuantity} 
                    handleProductFormAddQuantity={props.handleProductFormAddQuantity}
                    handleAddProductToCart={props.handleAddProductToCart}
                    addToCartError={props.addToCartError}
                    // Product
                    productDetails={props.productDetails}
                    productFormData={props.productFormData}
                    handleProductFormChange={props.handleProductFormChange} 
                    handleModFormChange={props.handleModFormChange}
                    // Product Combo
                    handleProductComboGroupSelect={props.handleProductComboGroupSelect}
                    // Modifier Combo
                    handleModifierComboSelect={props.handleModifierComboSelect}
                    handleBackModifierComboSelect={props.handleBackModifierComboSelect}
                    handleRemoveModifierComboFromProduct={props.handleRemoveModifierComboFromProduct}
                />
            </>
    } else if (props.productModalDisplay.showModalPage === "Modifier Combo Groups List") { // Regular Product - Modifier Groups List inside selected Modifier Combo
        let modifierComboGroupFormData =  props.productFormData.data.Mods.find((item) => {
            return item.fieldName == `ModComboModCatId${props.modifierComboDetails.modifierComboDetails.modCategoryId}`
        });

        modalBody = 
        <>
            <div className="modal-header">
                <button type="button" className="btn btn-light rounded-pill" onClick={props.handleBackModifierComboSelect}>
                    <img src={backIcon} alt="Back" title="Back" style={{width: "20px"}}></img>
                </button>
                <h1 className="modal-title fs-5">&emsp;Add Combo to Product</h1>
                <button type="button" className="btn-close" aria-label="Close" onClick={props.handleProductModalClose}></button>
            </div>
            <ModifierComboGroupsListModalPage
                modifierComboDetails={props.modifierComboDetails}
                modifierComboGroupFormData={modifierComboGroupFormData} // Passing productFormData only for selected Modifier Combo
                handleModifierComboGroupSelect={props.handleModifierComboGroupSelect}
                handleModComboAddComboToProduct={props.handleModComboAddComboToProduct}
                currentLocation={props.currentLocation}
                errorModifierCombo={props.errorModifierCombo}
            /> 
        </>
    } else if (props.productModalDisplay.showModalPage === "Modifier Combo Group Details") { // Regular Product - Modifier Group Details inside selected Group inside selected Modifier Combo
        let modifierComboFormData =  props.productFormData.data.Mods.find((modCombo) => { // Finding the formData that contains the modifier combo
            return modCombo.fieldName == `ModComboModCatId${props.modifierComboDetails.modifierComboDetails.modCategoryId}`
        });
        
        modalBody = 
        <>
            <div className="modal-header">
                <button type="button" className="btn btn-light rounded-pill" onClick={props.handleBackModifierComboGroupSelect}>
                    <img src={backIcon} alt="Back" title="Back" style={{width: "20px"}}></img>
                </button>
                <h1 className="modal-title fs-5">&emsp;Add selection to Combo</h1>
                <button type="button" className="btn-close" aria-label="Close" onClick={props.handleProductModalClose}></button>
            </div>
            <ModifierComboGroupDetailsModalPage
                modifierComboDetails={props.modifierComboDetails} 
                modifierComboFormData={modifierComboFormData}
                handleModifierChangeModComboGroup={props.handleModifierChangeModComboGroup}
                handleModifierComboAddSelectionToGroup={props.handleModifierComboAddSelectionToGroup}
                currentLocation={props.currentLocation}
                errorModifierCombo={props.errorModifierCombo}
            />
        </>
    } else if (props.productModalDisplay.showModalPage === "Product Combo List") { // Product Combo - Selection List
        modalBody = 
            <>
                <div className="modal-header">
                    <button type="button" className="btn btn-light rounded-pill" onClick={props.handleBackProductComboGroupSelect}>
                        <img src={backIcon} alt="Back" title="Back" style={{width: "20px"}}></img>
                    </button>
                    <h1 className="modal-title fs-5">&emsp;Select Product</h1>
                    <button type="button" className="btn-close" aria-label="Close" onClick={props.handleProductModalClose}></button>
                </div>
                <ProductComboListModalPage
                    productDetails={props.productDetails}
                    productComboChildDetails={props.productComboChildDetails}
                    handleSelectProductInComboList={props.handleSelectProductInComboList}
                />
            </>
    } else if (props.productModalDisplay.showModalPage === "Product Combo Child Details") { // Product Combo Child Product - Details
        modalBody = 
            <>
                <div className="modal-header">
                    <button type="button" className="btn btn-light rounded-pill" onClick={props.handleBackProductComboChild} disabled={props.addToProductComboError.ButtonsDisabled}>
                        <img src={backIcon} alt="Back" title="Back" style={{width: "20px"}}></img>
                    </button>
                    <h1 className="modal-title fs-5">&emsp;Product Details</h1>
                    <button type="button" className="btn-close" aria-label="Close" onClick={props.handleProductModalClose} disabled={props.addToProductComboError.ButtonsDisabled}></button>
                </div>
                <ProductComboChildModalPage 
                    productComboChildDetails={props.productComboChildDetails}
                    productComboChildFormData={props.productComboChildFormData}
                    currentLocation={props.currentLocation}
                    handleProductComboChildFormChange={props.handleProductComboChildFormChange}
                    handleProductComboModFormChange={props.handleProductComboModFormChange}
                    handleAddToProductCombo={props.handleAddToProductCombo}
                    addToProductComboError={props.addToProductComboError}
                />
            </>
    }

    return(
        <>
            <Modal show={props.productModalDisplay.showProductModal} backdrop="static" keyboard={false}>
                {modalBody}
            </Modal>  
        </>
    )
}